/**
 * @file Route: tiletalk
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { $, $all, forEach, on } from "@olmokit/dom";
import "components/Card/Blogpost";
import { Header } from "components/Header/Info";
// import { clickCta } from "components/Dl";
// import {
  //   glide,
  //   LazyLoad,
  //   Anchors,
  //   Breakpoints,
//   Controls,
//   Swipe,
// } from "@acanto/frontend/glide";
// import { breakpoints } from "@acanto/frontend/scss";
// import "components/CardStylevideo";
import "./index.scss";

console.log("Route tiletalk/index.js mounted.");

Header();

const ctas = $all(".dlClickCta");
if (ctas) {
  forEach(ctas, c => {
    on(c, "click", () => {
    //   clickCta(c.getAttribute("data-link"), c.getAttribute("data-label"));
    });
  });
}

// glide(".styles:.glide", {
//   loop: false,
//   bound: true,
//   sizeByTrack: true,
//   perView: 5,
//   breakpoints: {
//     [breakpoints.xl]: {
//       perView: 4,
//     },
//     [breakpoints.lg]: {
//       perView: 3,
//     },
//     [breakpoints.md]: {
//       perView: 2,
//     },
//     [breakpoints.sm]: {
//       perView: 1,
//     },
//   },
// }).mount({ Swipe, LazyLoad, Anchors, Breakpoints, Controls });